import { useLingui } from '@lingui/react/macro'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { LucideIcon } from 'components/LucideIcon'
import { NavbarButtonContainer } from 'features/navbar/NavbarButtonContainer'
import {
  StyledDropdownMenuContent,
  StyledDropdownMenuTrigger,
} from 'features/navbar/NavbarDropdown'
import React from 'react'

import { ConfigSettingsBase } from './ConfigSettingsBase'
import { ConfigSettingsTopBarMenuItems } from './ConfigSettingsTopBarMenuItems'
import { type ConfigSettingsProps } from './useConfigSettingsState'

export const ConfigSettingsTopBar: React.FC<ConfigSettingsProps> = ({
  orgID,
  siteID,
}) => {
  const { t } = useLingui()
  return (
    <ConfigSettingsBase
      orgID={orgID}
      renderTrigger={(state) => (
        <StyledDropdownMenuTrigger asChild>
          <NavbarButtonContainer
            $isSelected={state.isOpen}
            aria-label={t`Open config settings menu`}
            aria-expanded={state.isOpen}
            onClick={() => state.setIsOpen((o) => !o)}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                state.setIsOpen((o) => !o)
              }
            }}>
            <LucideIcon name='Settings' size={18} />
          </NavbarButtonContainer>
        </StyledDropdownMenuTrigger>
      )}
      renderContent={(state) => (
        <DropdownMenu.Portal>
          <StyledDropdownMenuContent sideOffset={12} align='end'>
            <ConfigSettingsTopBarMenuItems
              orgID={orgID}
              siteID={siteID}
              state={state}
            />
          </StyledDropdownMenuContent>
        </DropdownMenu.Portal>
      )}
    />
  )
}
